export const valueColorCodeCheck = (item) => {
  // If it's a string
  if (typeof item === "string") {
    try {
      // Try parsing it as JSON in case it's a stringified object
      const parsed = JSON.parse(item);
      if (parsed && typeof parsed === "object" && parsed.value !== undefined) {
        return parsed.value;
      }
      return item; // It's just a normal string
    } catch (e) {
      return item; // Not a JSON string, return as is
    }
  }

  // If it's an object
  if (typeof item === "object" && item !== null) {
    return item.value;
  }

  // Fallback
  return null;
};
